<script lang="ts" setup>
import type { ImageType } from '~/graphql/misc';

const props = defineProps<{
    categories: {
        slug: string,
        uri: string,
        posts: {
            nodes:  {
                title: string,
                uri: string,
                date: string,
                slug: string,
                databaseId: number,
                tags: {
                    nodes: {
                        name: string
                    }[]
                },
                categories: {
                    nodes: {
                        name: string
                    }[]
                },
                id: string,
                featuredImage: ImageType
            }[]
        }
    }[],
    postDatabaseId: number
}>();

const router = useRouter();
const relatedPosts: any = [];
const addedPostIds = new Set<number>();

props?.categories?.forEach(category => {
    category?.posts?.nodes?.forEach(post => {
        if (post && 
            props?.postDatabaseId !== post?.databaseId &&
            !addedPostIds.has(post.databaseId)) {
            relatedPosts.push(post);
            addedPostIds.add(post.databaseId);
        }
    });
});
</script>
<template>
    <div v-if="relatedPosts?.length > 0" class="related-posts-div-wrapper container-xl">
        <div class="title-wrapper d-flex justify-content-between align-items-center mb-5 flex-column-reverse flex-md-row gap-3 gap-md-0">
            <div class="related-title d-flex">
                <h1>Related Articles</h1>
            </div>
            <div class="action">
                <a href="#" class="btn btn-white rounded-pill text-uppercase with-border" @click.prevent="() => router.back()">
                    Back to insights
                </a>
            </div>
        </div>
        <div class="row g-4">
            <template v-for="(n,i) in 3">
                <Post v-if="relatedPosts[i]"
                    :post="{
                        title: relatedPosts[i].title,
                        uri: relatedPosts[i].uri,
                        date: relatedPosts[i].date,
                        slug: relatedPosts[i].slug,
                        tags: relatedPosts[i].tags,
                        categories: relatedPosts[i].categories,
                        id: relatedPosts[i].id,
                        featuredImage: relatedPosts[i].featuredImage
                    }"
                />
            </template>
        </div>
    </div>
</template>
